import { useSelector } from 'react-redux'

import { RootState } from 'types'

export const useCurrentArticleId = () => useSelector(({ currentArticleId }: RootState) => currentArticleId)
